export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 px-6 md:px-14 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Busy%20modern%20international%20shipping%20warehouse%20interior%20with%20conveyor%20belts%20and%20colorful%20packaged%20parcels%20moving%20through%20automated%20sorting%20system%2C%20bright%20industrial%20fluorescent%20overhead%20lighting%2C%20organized%20logistics%20atmosphere%2C%20blue%20and%20orange%20shipping%20labels%20visible%2C%20editorial%20business%20photography%2C%20no%20text%20no%20logos&width=1800&height=900&seq=cta-unique-03&orientation=landscape)',
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/75"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10 lg:gap-16">
        <div className="flex-1">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.12] mb-4">
            Start Shopping
            <br />
            Smarter Today
          </h2>
          <p className="text-white/70 text-base max-w-md leading-relaxed">
            Access the most complete curated spreadsheet system for shopping
            agents. Compare products, find the best prices, and shop with
            confidence.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full bg-white text-foreground-950 font-semibold text-sm whitespace-nowrap hover:bg-background-100 transition-all duration-300 flex items-center justify-center gap-3 group"
          >
            <span>Pandabuy Sheet</span>
            <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-white text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 flex items-center justify-center gap-3 group"
          >
            <span>Buy It Now</span>
            <span className="w-8 h-8 rounded-full bg-white/25 flex items-center justify-center">
              <i className="ri-shopping-cart-2-line text-white text-sm group-hover:translate-x-0.5 transition-transform"></i>
            </span>
          </a>
        </div>

        <div className="hidden lg:block">
          <p className="text-white/50 text-sm leading-relaxed max-w-[200px]">
            Free spreadsheet access &bull; No registration required &bull; Updated
            weekly with verified finds
          </p>
        </div>
      </div>
    </section>
  );
}